import * as React from 'react';
import TodayPage from '../components/TodayPage';
import Loader from '../components/Loader';
import NotFound from '../pages/NotFound';
import { useRequest } from '../api/client';

export interface Props {
  total_cups: number;
  total_coffee_weight: number;
  total_water_weight: number;
  top_countries: string[];
  top_brew_methods: string[];
  top_dose_ratio: number;
  top_dose_coffee: number;
  top_dose_water: number;
  brewed_with_ble: number;
}

const fetch = () => {
  return useRequest(() => ({
    url: '/stats/daily',
    method: 'GET',
  }));
};

export default () => {
  const [state, _] = fetch();

  if (state.loading) {
    return <Loader />;
  }

  if (!state.data) {
    return <NotFound />;
  }

  return (
    <TodayPage
      countries={state.data.top_countries}
      cups={state.data.total_cups}
      coffee={state.data.total_coffee_weight}
      water={state.data.total_water_weight}
      ratio={state.data.top_dose_ratio}
      brew_methods={state.data.top_brew_methods}
    />
  );
};
